module.exports = __webpack_public_path__ + "img/img3.eb9d7d18.jpg";